import '../../assets/styles/App.css';
import {useOutlet} from "react-router-dom";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import Container from "react-bootstrap/Container";

export default function PublicLayout() {
    const outlet = useOutlet();
    return (

        <Container fluid className={"vh-100 px-0 d-flex flex-column"}>
            <Header />
            <Container fluid className={"background-container d-flex flex-column flex-grow-1 my-3"}>
                {outlet}
            </Container>

            <Footer/>
        </Container>

    );
}
